var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgImportTql = function SvgImportTql(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ImportTQL_svg__ImportTQL_svg__clip0_178_730)",
    stroke: "#6E7D8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 3v4a1 1 0 001 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 13V5a2 2 0 012-2h7l5 5v11a2 2 0 01-2 2h-5.5m-9.5-2h7m0 0l-3-3m3 3l-3 3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ImportTQL_svg__ImportTQL_svg__clip0_178_730"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.75)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgImportTql;